import { Avatar } from '@material-ui/core'
import React from 'react'
import { includeComma } from '../../../services/globalFunctions'

const SingleRankTable = ({ data, rank }) => {
  const {
    profit,
    contest_id,
    initial_coins,
    name,
    value: invested,
    contestant_id,
    change_per
  } = data
  return (
    <tr className="text-xs xl:text-sm font-600 bg-purple-400 bg-opacity-10    ">
      <td className="flex items-center gap-4 justify-start px-8">
        <p>{rank}.</p>

        <p className="">{name}</p>
        {rank <= 3 && (
          <svg
            width="14"
            height="10"
            viewBox="0 0 14 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M13.3114 2.96598C12.7237 3.08017 12.1516 3.24538 11.6041 3.459C10.9362 3.72993 10.3053 4.06192 9.72291 4.449C9.31024 4.02036 8.95385 3.5551 8.66002 3.0614C8.19109 2.21457 7.795 1.34025 7.47484 0.445251C7.44465 0.360732 7.38204 0.287112 7.29688 0.236C7.21173 0.184888 7.10887 0.159191 7.00453 0.16296C6.90019 0.159191 6.79733 0.184888 6.71218 0.236C6.62702 0.287112 6.56441 0.360732 6.53422 0.445251C6.21484 1.34048 5.81874 2.21484 5.34905 3.0614C5.05659 3.55453 4.7001 4.0186 4.28615 4.44502C3.70097 4.06239 3.07053 3.73196 2.40492 3.459C1.87075 3.24822 1.31302 3.08307 0.740025 2.96598C0.654955 2.94871 0.56587 2.95183 0.482787 2.97501C0.399704 2.99819 0.325915 3.0405 0.269717 3.09719C0.212528 3.15576 0.176378 3.22695 0.165543 3.30234C0.154708 3.37773 0.169641 3.45417 0.208577 3.52261C1.10075 5.23759 1.73284 7.04106 2.08981 8.8901C2.10885 8.98345 2.16669 9.06799 2.25291 9.12849C2.33913 9.18899 2.44808 9.22148 2.56012 9.2201H11.496C11.608 9.22148 11.717 9.18899 11.8032 9.12849C11.8894 9.06799 11.9472 8.98345 11.9663 8.8901C12.3233 7.04106 12.9553 5.23759 13.8475 3.52261C13.8865 3.45417 13.9014 3.37773 13.8905 3.30234C13.8797 3.22695 13.8436 3.15576 13.7864 3.09719C13.7298 3.03979 13.6552 2.99704 13.5712 2.97384C13.4872 2.95063 13.3971 2.94791 13.3114 2.96598ZM3.64653 7.916C3.54308 7.91679 3.44169 7.89158 3.35523 7.84356C3.26876 7.79555 3.20112 7.72691 3.16089 7.64634C3.12065 7.56577 3.10964 7.47691 3.12925 7.39104C3.14886 7.30517 3.1982 7.22616 3.27102 7.16404C3.34384 7.10192 3.43685 7.05949 3.53824 7.04214C3.63963 7.02479 3.74484 7.03329 3.8405 7.06658C3.93617 7.09986 4.01798 7.15642 4.07555 7.22908C4.13313 7.30174 4.16387 7.38722 4.16387 7.47467C4.16388 7.59104 4.10952 7.70269 4.01263 7.78534C3.91575 7.86799 3.78417 7.91495 3.64653 7.916ZM7.00923 7.916C6.87993 7.90559 6.75987 7.85481 6.67249 7.77357C6.58511 7.69233 6.53669 7.58647 6.53669 7.47666C6.53669 7.36686 6.58511 7.261 6.67249 7.17976C6.75987 7.09852 6.87993 7.04773 7.00923 7.03732C7.13854 7.04773 7.2586 7.09852 7.34598 7.17976C7.43336 7.261 7.48178 7.36686 7.48178 7.47666C7.48178 7.58647 7.43336 7.69233 7.34598 7.77357C7.2586 7.85481 7.13854 7.90559 7.00923 7.916ZM10.3766 7.916C10.2732 7.91679 10.1718 7.89158 10.0853 7.84356C9.99887 7.79555 9.93123 7.72691 9.891 7.64634C9.85076 7.56577 9.83975 7.47691 9.85936 7.39104C9.87897 7.30517 9.92831 7.22616 10.0011 7.16404C10.074 7.10192 10.167 7.05949 10.2684 7.04214C10.3697 7.02479 10.4749 7.03329 10.5706 7.06658C10.6663 7.09986 10.7481 7.15642 10.8057 7.22908C10.8632 7.30174 10.894 7.38722 10.894 7.47467C10.894 7.59104 10.8396 7.70269 10.7427 7.78534C10.6459 7.86799 10.5143 7.91495 10.3766 7.916Z"
              fill="#31ACAC"
            />
          </svg>
        )}
      </td>

      <td className="text-center">
        <p>{includeComma(initial_coins)} $</p>
      </td>

      <td className="text-center">
        {profit === null ? (
          <p>0 $</p>
        ) : (
          <p className={`text-${profit < 0 ? `red` : `green`}-500`}>
            {includeComma((profit > 1000 || profit < -1000 ? profit / 1000 : profit).toFixed(2))}
            {(profit > 1000 || profit < -1000) && ` k`} $
          </p>
        )}
      </td>

      {/* <td className={`text-center ${percentage >= 0 ? `text-green-500` : `text-red-500`}`}>
        <p>{percentage.toFixed(2)}%</p>
      </td> */}
      <td className={` text-center text-${change_per < 0 ? `red` : `green`}-500`}>
        {change_per === null ? <p>0 %</p> : <p>{includeComma(change_per.toFixed(2))}%</p>}
      </td>
      <td className="text-center">
        {invested === null ? (
          <p>0 $</p>
        ) : (
          <p>
            {includeComma(
              (invested > 1000 || invested < -1000 ? invested / 1000 : invested).toFixed(2)
            )}
            {(invested < -1000 || invested > 1000) && ` k`} $
          </p>
        )}
      </td>
    </tr>
  )
}

export default SingleRankTable
